<template>
  <div>
    <special-index v-show="special && special['index/index']" :page-path="'index/index'" :item-id="''"></special-index>

    <div class="container" v-show="!special || !special['index/index']">

      <home-common-search :from='"home"'></home-common-search>

      <index-banner v-if="banners && banners.length > 0" :items="banners"></index-banner>

      <index-menu :items="navs"></index-menu>

      <!-- <index-article :items="articles"></index-article> -->

      <mt-swipe class="banner" style="height: 4.1rem;margin: .4rem .7rem 1rem;" :speed="600" :show-indicators="false">
        <mt-swipe-item>
          <img src="../../../assets/image/home/gobuy.png" @click="gotobuy" alt="gobuy">
        </mt-swipe-item>
        <mt-swipe-item>
          <img src="../../../assets/image/member/Recycle.png" @click="goGiftSave" alt="Recycle">
        </mt-swipe-item>
      </mt-swipe>

      <CategoryCarousel v-if="class_list.length > 0" :data="class_list" />

      <index-three-ads :items="promotionAds"></index-three-ads>

      <div class="tabs">
        <div class="tab" v-for="(item, index) in tabs" :key="index" :class="{ active: index === activeTab }"
          @click="tabClick(item, index)">{{ $t(item.gc_name) }}</div>
      </div>

      <index-floor-ads v-if="floorAds" :ad="floorAds[0]"></index-floor-ads>

      <index-product-list :items="list" :type="popular" v-if="list && list.length > 0"></index-product-list>

      <index-floor-ads v-if="floorAds" :ad="floorAds[1]"></index-floor-ads>

      <!-- <index-product-list :items="hotProducts" title="销量排行" :type="sale"
        v-if="hotProducts && hotProducts.length > 0"></index-product-list>

      <index-floor-ads v-if="floorAds" :ad="floorAds[2]"></index-floor-ads>

      <index-product-list :items="recentlyProducts" title="新品上架" :type="recently"
        v-if="recentlyProducts && recentlyProducts.length > 0"></index-product-list> -->

      <!-- 版权信息 -->
      <div class="copyright">
        <!-- <div>
          <a class="link" href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank">
            {{ config.wab_number
            }}</a>
        </div>
        <div><a class="link" href="https://beian.miit.gov.cn" target="_blank">{{ config.icp_number }}</a></div>
        <div>{{ config.flow_static_code }}</div> -->

        <div class="item">
          <div class="t">{{ $t('Download our app') }}</div>
          <div class="list">

            <div class="iit">
              <div class="l icon">
                <img src="../../../assets/image/home/pg.png" alt="pg">
              </div>
              <div class="r">
                <div class="t">{{ $t('Download it from') }}</div>
                <div class="tt">APP STORE</div>
              </div>
            </div>

            <div class="iit">
              <div class="l icon">
                <img src="../../../assets/image/home/gg.png" alt="gg">
              </div>
              <div class="r">
                <div class="t">{{ $t('Download it from') }}</div>
                <div class="tt">GOOGLE PLAY</div>
              </div>
            </div>

          </div>
        </div>

        <!-- <div class="item" >
          <div class="t">{{ $t('About Us') }}</div>
        </div> -->

        <div class="item" @click="gotoFuwenben(2, 'account')">
          <div class="t">{{ $t('Account correlation') }}</div>
          <div class="text" v-for="item in  bomList1">{{ item.question }}</div>
        </div>
        <div class="item" @click="gotoFuwenben(2, 'order')">
          <div class="t">{{ $t('Order management') }}</div>
          <div class="text" v-for="item in  bomList2">{{ item.question }}</div>
        </div>
        <div class="item" @click="gotoFuwenben(2, 'pay')">
          <div class="t">{{ $t('Payment method') }}</div>
          <div class="text" v-for="item in  bomList3">{{ item.question }}</div>
        </div>
        <div class="item" @click="gotoFuwenben(2, 'shipping')">
          <div class="t">{{ $t('Shipping and distribution') }}</div>
          <div class="text" v-for="item in  bomList4">{{ item.question }}</div>
        </div>
        <div class="item" @click="gotoFuwenben(2, 'refund')">
          <div class="t">{{ $t('Return and exchange policy') }}</div>
          <div class="text" v-for="item in  bomList5">{{ item.question }}</div>
        </div>
        <div class="item" @click="gotoFuwenben(2, 'service')">
          <div class="t">{{ $t('Customer service') }}</div>
          <div class="text" v-for="item in  bomList6">{{ item.question }}</div>

          <div class="text" @click.stop="gotoFuwenben(1)">{{ $t('About Us') }}</div>
          <div class="text" @click.stop="getEmail">{{ $t('Contact us') }}</div>
        </div>
        <div class="item" @click="gotoFuwenben(2, 'security')">
          <div class="t">{{ $t('Privacy Policy and Terms of Use') }}</div>
          <div class="text" v-for="item in  bomList7">{{ item.question }}</div>
        </div>
        <!-- <div class="item">
          <div class="t">{{ $t('Contact us') }}</div>
        </div> -->
        <!-- 
        <div class="item" @click="gotoFuwenben(2)">
          <div class="t">{{ $t('Customer service') }}</div>
          <div class="text">{{ $t('frequently asked question') }}</div>
          <div class="text">{{ $t('Return and exchange policy') }}</div>
          <div class="text">{{ $t('Shipping and distribution') }}</div>
          <div class="text">{{ $t('Contact us by email') }}</div>
        </div>

        <div class="item" @click="gotoFuwenben(3)">
          <div class="t">{{ $t('Privacy Policy and Terms of Use') }}</div>
          <div class="text">{{ $t('Privacy Policy') }}</div>
          <div class="text">{{ $t('Terms of use') }}</div>
        </div> -->

        <div class="icons">

          <div class="icon" v-for="item in iconList">
            <a :href="item.link" target="_blank">
              <img :src="item.src">
            </a>
          </div>
        </div>
        <div class="item" style="margin: 0;">
          <div class="text">{{ $t('address') }}: {{ '4255 South Buckley Road #1296 Aurora CO 80013 USA' }}</div>
        </div>
      </div>

      <div class="lang" @click="setLang">
        <img src="../../../assets/image/lang.png" alt="">
      </div>

      <!-- popup -->
      <mt-popup v-model="popupVisible" popup-transition="popup-fade" position="bottom">
        <div class="picker-toolbar-title">
          <div class="usi-btn-cancel" @click="popupVisible = !popupVisible">
            {{ $t('MessageBox.Cancel') }}
          </div>
          <div class="">{{ $t('Language selection') }}</div>
          <div class="usi-btn-sure" @click="addrConfirm">{{ $t('MessageBox.Confirm') }}</div>
        </div>
        <mt-picker ref="picker" :slots="slots" value-key="en" :itemHeight="50" @change="onValuesChange"
          v-if="slots[0].values.length > 0" @touchmove.native.stop.prevent></mt-picker>
      </mt-popup>
    </div>

    <audio src="../../../assets/image/gobuy/44s.mp3" muted style="display: none;"></audio>
    <audio src="../../../assets/image/gobuy/15s.mp3" muted style="display: none;"></audio>
  </div>
</template>

<script>
import { Goodsclass, GoodsList, goods_index_list, get_contact_info, getLangList, change_lang } from '../../../api/homeindex'
import { getAboutContent } from '../../../api/homeArticle'
import { getAddressInfo } from '../../../api/memberBuy'
import axios from 'axios';
import store from '../../../store'
import { mapState, mapActions } from 'vuex'
import { Toast } from 'mint-ui'
import SpecialIndex from '../special/Index'
import IndexProductList from './IndexProductList'
import HomeCommonSearch from '../common/HomeCommonSearch'
import IndexBanner from './IndexBanner'
import IndexMenu from './IndexMenu'
import IndexFloorAds from './IndexFloorAds'
import IndexThreeAds from './IndexThreeAds'
import IndexArticle from './IndexArticle'
import CategoryCarousel from './CategoryCarousel'
export default {
  name: 'HomeIndex',
  data() {
    return {
      isshowBacktop: true,
      popular: '',
      sale: 'goods_salenum',
      recently: 'goods_addtime',
      tabs: [
        {
          gc_name: 'TodaysOffer'
        }
      ],
      activeTab: 0,
      list: [],
      // ECharts 实例
      chartInstance: null,
      slots: [
        {
          values: []
        }
      ],
      popupVisible: false,
      class_list: [],
      bomList1: [],
      bomList2: [],
      bomList3: [],
      bomList4: [],
      bomList5: [],
      bomList6: [],
      bomList7: [],
      iconList: [
        {
          src: require('../../../assets/image/home/b1.png'),
          type: 'Facebook'
        },
        {
          src: require('../../../assets/image/home/b2.png'),
          type: 'Twitter'
        },
        {
          src: require('../../../assets/image/home/b3.png'),
          type: 'YouTube'
        },
        {
          src: require('../../../assets/image/home/b4.png'),
          type: 'Instagram'
        },
        {
          src: require('../../../assets/image/home/b5.png'),
          type: 'LinkedIn'
        },
        {
          src: require('../../../assets/image/home/b6.png'),
          type: 'TikTok'
        },
      ],
      address_info: null,
    }
  },
  components: {
    SpecialIndex,
    IndexProductList,
    HomeCommonSearch,
    IndexBanner,
    IndexMenu,
    IndexFloorAds,
    IndexThreeAds,
    IndexArticle,
    CategoryCarousel
  },
  mounted() {
    getAboutContent('account').then(res => {
      this.bomList1 = res.result.list
    })
    getAboutContent('order').then(res => {
      this.bomList2 = res.result.list
    })
    getAboutContent('pay').then(res => {
      this.bomList3 = res.result.list
    })
    getAboutContent('shipping').then(res => {
      this.bomList4 = res.result.list
    })
    getAboutContent('refund').then(res => {
      this.bomList5 = res.result.list
    })
    getAboutContent('service').then(res => {
      this.bomList6 = res.result.list
    })
    getAboutContent('security').then(res => {
      this.bomList7 = res.result.list
    })
    getAddressInfo().then(res => {
      if (res.code == 10000) {
        this.address_info = res.result
      }
    })

    Goodsclass().then(res => {
      // for (let i = 0; i < res.result.length; i++) {
      //   this.tabs.push(res.result[i])
      // }
      this.class_list = res.result

      this.getList()
    })

    // console.log('fetchMessageCount');
    // this.fetchMessageCount();
  },
  created: function () {
    this.utils.preloadImages(['https://ysmhh.s3.amazonaws.com/1.gif', 'https://ysmhh.s3.amazonaws.com/2.gif'])

    get_contact_info().then(res => {
      // this.list = res.result.goods_list
      // 遍历 iconList 并添加 link 属性
      this.iconList.forEach(icon => {
        // 查找与 type 匹配的链接
        const link = res.data[icon.type];
        // 如果找到了链接，则添加到当前 icon 对象
        if (link) {
          icon.link = link;
        }
      });
    })

    this.fetchHomeAd({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchHomeArticle({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchHomeProduct({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchConfig({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
  },
  computed: {
    ...mapState({
      special: state => state.home.special,
      config: state => state.config.config,
      banners: state => state.home.banners,
      navs: state => state.home.navs,
      floorAds: state => state.home.floorAds,
      promotionAds: state => state.home.promotionAds,
      articles: state => state.home.articles,
      hotProducts: state => state.home.hotProducts,
      recentlyProducts: state => state.home.recentlyProducts,
      goodProducts: state => state.home.goodProducts
    })
  },
  methods: {
    ...mapActions({
      fetchHomeAd: 'fetchHomeAd',
      fetchHomeArticle: 'fetchHomeArticle',
      fetchHomeProduct: 'fetchHomeProduct',
      fetchConfig: 'fetchConfig'
    }),
    gotoFuwenben(id, type) {
      this.$router.push({ name: 'HomeDocument', query: { id: id, type: type } })
    },
    getEmail() {
      this.$router.push({ name: 'MemberContactUs' })
    },
    tabClick(item, index) {
      this.activeTab = index

      this.getList(item.id)
    },
    getList(id) {
      goods_index_list(id).then(res => {
        this.list = res.result.goods_list
      })
      // GoodsList(id).then(res => {
      //   this.list = res.result.goods_list
      // })
    },
    gotobuy() {
      this.$router.push({ name: 'HomeGoBuy' })
    },
    goGiftSave() {
      this.$router.push({
        name: 'GiftSave'
      })
    },
    setLang() {
      // this.popupVisible = true;
      this.$router.push({ name: 'HomeLang' })
    },
    onValuesChange(picker, values) {
      this.product = values[0].en;
    },
    addrConfirm() {
      console.log(this.product);
      // 本地存储
      if (this.product == 'en-us') {
        this.$i18n.locale = 'en'
        this.utils.save('lang', 'en')
        this.utils.save("locale", 'en');
      } else {
        this.$i18n.locale = this.product
        this.utils.save('lang', this.product)
        this.utils.save("locale", this.product);
      }
      // 切换语言
      this.change_lang(this.product)
      this.popupVisible = false;
    },
    change_lang(lang) {
      change_lang(lang).then(res => {
        this.getLangList()
      })
    },
    getLangList() {
      getLangList().then(res => {
        this.slots[0].values = res.result
      })
    },
  }
}
</script>

<style scoped lang="scss">
.copyright {
  font-size: $fontSize;
  color: #c5c5c5;
  text-align: center;
  margin: 1rem 0;
  padding: 1rem;
  border-top: 1px solid #bdbdbd;
  background: linear-gradient(224deg, #FEE5CD, transparent);

  .item {
    padding: .4rem 0;
    margin: 0 0 1.5rem 0;

    &:first-child {
      border-bottom: 1px solid #bdbdbd;
    }

    .t {
      // margin-bottom: .4rem;
      text-align: left;
      font-size: .8rem;
      color: #000;
      font-weight: 600;
    }

    .list {
      .iit {
        width: 8rem;
        margin: 15px 0;
        padding: 10px;
        background: #ffffff;
        border-radius: 5px 5px 5px 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .icon {

          img {
            width: 30px;
            display: block;
          }
        }

        .r {
          .t {
            font-size: 12px;
            color: #8a8099;
            margin: 0;
          }

          .tt {
            font-size: 14px;
            font-weight: 600;
            color: #000;
          }
        }
      }
    }

    .text {
      text-align: left;
      margin: .5rem 0;
      color: #7F7F7F;
    }
  }

  .icons {
    width: 60%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .icon {
      width: 1rem;
      height: 1rem;

      img {
        width: 100%;
        height: 100%;

      }
    }
  }

  .link {
    color: #c5c5c5
  }
}

.container {
  background: #fff;
  padding-bottom: 1px;
}

.tabs {
  padding-left: .7rem;
  padding-right: .7rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 .5rem;
  height: 1.5rem;
  background: #fff;

  .tab {
    // flex: 1;
    text-align: center;
    font-size: $fontSize;
    color: #333;
    padding: 7px 16px;
  }

  .active {
    color: #fff;
    background: #FB2933;
    border-radius: 10px 10px 10px 10px;
  }
}

.banner_ {
  margin: 0 10px 30px;

  img {
    width: 100%;
    height: 100%;
  }
}

.lang {
  position: fixed;
  top: 5px;
  right: 5px;
  z-index: 99;

  img {
    width: 1.5rem;
  }
}

.picker-toolbar-title {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  background: #f5f5f5;
}

.usi-btn-cancel,
.usi-btn-sure {
  color: #108ee9;
}

::v-deep .product-list-header {
  padding-left: 0;
  padding-right: 40px;

  .slot {
    width: 4.5rem !important;
    // display: none;
  }
}

::v-deep .picker {
  .picker-items {
    width: 100%;
  }

  .picker-slot {
    flex: 1;
  }
}

.banner {

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
